module.exports = __webpack_public_path__ + "img/divide-solid.a20d8c3c.svg";